import{split as t}from"ramda";const a=t(".");export{a as getPath};
